import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_wellness_self_care: FaireThemeEntity = {
  token: "discovery_theme_wellness-self-care",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Wellness & Self-Care",
  description: "Products for relaxation and well-being",
  bgColor: "#D8EDE0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
